import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions";
import sampleCombine from 'xstream/extra/sampleCombine';

export function fetchStoresAfterUpdateCollection(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestUpdateStoresCollection')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 204)
    .map(response => actions.getStores({}));

  return {
    ACTION: httpResponse$
  }
}

export function requestUpdateStoresCollection(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_STORES_COLLECTION)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/stores/collection',
      category: 'requestUpdateStoresCollection',
      method: 'PATCH',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestUpdateStoresCollection')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 204)
    .map(response => actions.updateStoresCollectionSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestUpdateStoresCollectionFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestUpdateStoresCollection')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 204)
    .map(response => actions.updateStoresCollectionFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestCities(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_CITIES)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/stores/cities',
      category: 'requestCities',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCities')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getCitiesSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCitiesFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCities')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getCitiesFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestStoresSuggestions(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_STORES_SUGGESTIONS)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/stores' + ( action.payload.filter?('?filter=' + JSON.stringify(action.payload.filter)):''),
      category: 'requestStoresSuggestions',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestStoresSuggestions')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getStoresSuggestionsSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestStoresSuggestionsFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestStoresSuggestions')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getStoresSuggestionsFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestStores(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_STORES)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/stores' + ( action.payload.filter?('?filter=' + JSON.stringify(action.payload.filter)):''),
      category: 'requestStores',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestStores')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getStoresSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestStoresFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestStores')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getStoresFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/stores.js